/**
 * Created by hzyanming on 17/6/28.
 */
import Tab from './Tab'

export default Tab
